<template>
  <div id="total-consumption" class="total-consumption">
    <div class="body">
      <highcharts :options="options"></highcharts>
    </div>
  </div>
</template>

<script>

import requests from '../../requests';

  export default {
    name:'total-consumption',
    props: {
      data: Number,
    },
    data() {
      return {
        options: {
          credits: {
            enabled: false
          },
           chart: {
             type: 'solidgauge',
             height: 200,
              marginTop: 0
           },
          title: {
            text:''
          },

          pane: {
              startAngle: 0,
              endAngle: 360,
              size:'110%',
              background: [{ // Track for Move
                  outerRadius: '90%',
                  innerRadius: '80%',
                  backgroundColor:'#D7E9F9',
                  borderWidth: 0
              }]
          },

          yAxis: {
              min: 0,
              max: 100,
              lineWidth: 0,
              tickPositions: []
          },

          tooltip: {
            enabled: false
          },

          plotOptions: {
              solidgauge: {
                  dataLabels: {
                    align: "center",
                    enabled: true,
                    format: '<div style="text-align: center"><span style="color: black">{y}kWh</span><div class="clear"></div><span style="font-weight: 200">Total<div class="clear"></div>Usage</span><div>',
                    borderColor: 'none',
                    style:{"fontSize":'calc(5px + 0.6vw)', color:'#ADADAD',"textOutline": "none", "text-aign":"center"},
                    y: -30,
                    useHTML: true,
                    className:'usage-label'
                  },
                  linecap: 'round',
                  stickyTracking: false,
                  rounded: true
              }
          },

          series: [{
              name: 'Usage',
              data: [{
                  color: '#01809E',
                  radius: '90%',
                  innerRadius: '80%',
                  y: 100
              }],
              title: "total Usage"
          }]
        }

      }
    },
    beforeMount() {


    },
    watch: {
      data() {
          this.options.series[0].data[0].y = parseFloat(this.data)


      }
    }
  }
</script>

<style>
.total-consumption div.body{
  padding:0;
}

path.highcharts-pane {
  width:115%;
}





</style>


// WEBPACK FOOTER //
// TotalConsumption.vue?7eed61bd